import React, { useState, useEffect, useRef } from "react";
import "./SoftwareSolutionsSection2.css";
import Image1 from "../../../assets/servicessoftware1.png";
import Image2 from "../../../assets/Item2.png";
import Image3 from "../../../assets/servicessoftware3.png";
import { useTranslation } from "react-i18next";

const SoftwareSolutionsSection2 = () => {
  const { t } = useTranslation("global");
  const [activeSlide, setActiveSlide] = useState(0);
  const sliderRef = useRef(null);
  const cardRefs = useRef([]);

  // Set up intersection observer to detect which card is in view
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.6, // Card is considered in view when 60% visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = cardRefs.current.findIndex(
            (ref) => ref === entry.target
          );
          if (index !== -1) {
            setActiveSlide(index);
          }
        }
      });
    }, options);

    const currentRefs = cardRefs.current;
    // Observe all card elements
    currentRefs.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => {
      currentRefs.forEach((card) => {
        if (card) observer.unobserve(card);
      });
    };
  }, []);

  // Scroll to a specific card when indicator is clicked
  const scrollToCard = (index) => {
    if (cardRefs.current[index]) {
      cardRefs.current[index].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
      setActiveSlide(index);
    }
  };

  // Services data
  const services = [
    {
      imageSrc: Image1,
      imageAlt: t("softwareSolutions.softwareSolutions2.services.title"),
      title: t("softwareSolutions.softwareSolutions2.services.title"),
      description: t(
        "softwareSolutions.softwareSolutions2.services.description"
      ),
    },
    {
      imageSrc: Image2,
      imageAlt: t("softwareSolutions.softwareSolutions2.services.title2"),
      title: t("softwareSolutions.softwareSolutions2.services.title2"),
      description: t(
        "softwareSolutions.softwareSolutions2.services.description2"
      ),
    },
    {
      imageSrc: Image3,
      imageAlt: t("softwareSolutions.softwareSolutions2.services.title3"),
      title: t("softwareSolutions.softwareSolutions2.services.title3"),
      description: t(
        "softwareSolutions.softwareSolutions2.services.description3"
      ),
    },
  ];

  return (
    <section className="digital-services-container">
      <header className="header-section">
        <h2 className="main-heading">
          {t("softwareSolutions.softwareSolutions2.heading")}
        </h2>
        <p className="subtitle">
          {t("softwareSolutions.softwareSolutions2.text")}
        </p>
      </header>

      <div className="services-grid" ref={sliderRef}>
        {services.map((service, index) => (
          <ServiceCard
            key={index}
            ref={(el) => (cardRefs.current[index] = el)}
            imageSrc={service.imageSrc}
            imageAlt={service.imageAlt}
            title={service.title}
            description={service.description}
          />
        ))}
      </div>

      {/* Slider indicators for mobile */}
      <nav className="slider-indicators">
        {services.map((_, index) => (
          <div
            key={index}
            className={`slider-dot ${activeSlide === index ? "active" : ""}`}
            onClick={() => scrollToCard(index)}
            aria-label={`Go to slide ${index + 1}`}
            aria-current={activeSlide === index ? "true" : "false"}
          />
        ))}
      </nav>
    </section>
  );
};

const ServiceCard = React.forwardRef(
  ({ imageSrc, imageAlt, title, description }, ref) => {
    return (
      <article className="service-card-softwaresolutions" ref={ref}>
        <figure className="icon-container">
          <img
            src={imageSrc || "/placeholder.svg"}
            alt={imageAlt}
            className="service-icon-software"
          />
        </figure>
        <header className="title-container">
          <h3 className="card-title">{title}</h3>
        </header>
        <p className="card-description">{description}</p>
      </article>
    );
  }
);

export default SoftwareSolutionsSection2;
